import React, {useEffect, useState} from "react";
import { QRCodeCanvas } from 'qrcode.react';
import useFirebaseFunction from "../utils/useFirebaseFunction";
import {LoadingOverlay} from "@mantine/core";


export default function LoginQR({path,size}) {
    const [generate_auth_token, isTokenLoading] = useFirebaseFunction("generate_auth_token", "europe-west1");
    const [token, setToken] = useState(null);

    useEffect(() => {
        generate_auth_token().then(({data}) => setToken(data));
    }, []);


    if (!token) {
        return <LoadingOverlay visible={true}/>
    }
    return ( <QRCodeCanvas size={size ? size : 300} value={`https://picboard.ro/${path}?selfie=1&token=${token}`} />)
}